import { render, staticRenderFns } from "./ToolMetaTab.vue?vue&type=template&id=84f8ebc0"
import script from "./ToolMetaTab.vue?vue&type=script&lang=js"
export * from "./ToolMetaTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports